import React, { useEffect, useState, useRef } from 'react';
import { isValidEmail } from '../utils/utils';
import CaptchaSubscribePopup from '../components/Popup/captcha-subscribe-popup';
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const SubscribePage = (props) => {
  const captchaSubscribePopupRef = useRef(null);
  const [invitedEmail, setInvitedEmail] = useState('');
  
  const inviteSubcriber = (e) => {
    e.preventDefault();
    if (invitedEmail && isValidEmail(invitedEmail)) {
      // open captcha subscribe popup
      captchaSubscribePopupRef.current.open(invitedEmail);
    } else {
      alert('Please enter your valid email.');
    }
  }
  return (
    <>
      <div className="col-12 col-md-6 offset-md-3 mt-10 wow fadeInUp delay-04s">
        <div className="theme-card">
          <p>
            <strong> Inventiv Announces Early Access To Its
              Online Provisional Filing Tools For Individual Inventors </strong>
          </p>
          <p className="sec-clr">
            <strong> Beta Testers Are Invited </strong>
          </p>
          <form action="">
            <div className="row">
              <div className="col-12 col-md-8 my-1">
                <div className="input-group">
                  <span className="input-group-addon"><i className="fa fa-envelope d-clr"></i></span>
                  <input type="text" className="form-control" placeholder="Your Email" required value={invitedEmail} onChange={e => setInvitedEmail(e.target.value)} />
                </div>
              </div>
              <div className="btn-box col-12 col-md-3 my-1">
                <input type="button" className="btn btn-default" value="Subscribe" onClick={inviteSubcriber} />
              </div>
            </div>
          </form>
        </div>
        <CaptchaSubscribePopup ref={captchaSubscribePopupRef} />
      </div>
    </>
  );
}

export default SubscribePage;
